/**
 * Created by Karan variya on 24/12/2018.
 */


import { NgModule }      from '@angular/core';
import { CommonModule }  from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule }  from '@angular/router';
import { BackupdbComponent }          from './backupdb.page';


export const routes: Routes = [
    { path: 'backupdb', component: BackupdbComponent}

];

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        RouterModule.forChild(routes)
    ],
    declarations: [
        BackupdbComponent
    ]
})

export class BackupdbModule { }


// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix HealthCare/HealthCare_UI/src/app/structure/backupDB/backupDB.module.ts